import { UserSegment } from '../models/user-segment.model';

export const USER_SEGMENTS: UserSegment[] = [
  {
    icon: '🎓',
    title: 'Students',
    description: 'Empowering you to achieve academic excellence with personalized learning tools and comprehensive support.',
    features: [
      'Interactive learning dashboard',
      'Real-time grade tracking',
      'Digital assignment submission',
      'Direct teacher communication',
      'Study anywhere with mobile access',
      'Personalized learning paths'
    ]
  },
  {
    icon: '👨‍👩‍👧‍👦',
    title: 'Parents',
    description: 'Stay connected with your child\'s academic journey through transparent communication and progress monitoring.',
    features: [
      'Live progress tracking',
      'Teacher messaging system',
      'Fee payment management',
      'Academic performance reports',
      'School event notifications',
      'Parent-teacher meeting scheduling'
    ]
  }
];
